/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AdminGroupsListState} from './admin-groups-list.reducer';

// Selector functions
const adminGroupsListData =
  createFeatureSelector<AdminGroupsListState>('ss-cord.admin-groups-list');


// Get Groups List
export const groupsList = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.groupsList
);

export const dashboardFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.dashboardFilter
);

export const clinicFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.clinicFilter
);

export const statusFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.statusFilter
);

export const groupTypeFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.groupTypeFilter
);

export const participantsAndCaregiversList = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.participantsAndCaregiversList
);

export const groupListFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.groupListFilter
);

export const userStatusListFilter = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.userStatusListFilter
);

export const participantsWeightList = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.participantsWeightList
);

export const configId = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.configId
);

export const participantsBehaviourList = createSelector(
  adminGroupsListData,
  (state: AdminGroupsListState) => state.participantsBehaviourList
);
